<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Analyte Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading :title="header" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read analyte'">
      <template #gated-content>
        <analyte-card v-if="analyte_id" :analyte="analyte" />

        <h3>Analyte Ranges</h3>
        <AnalyteRangeForm :analyte="analyte" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import { getModel } from '@/shared/fetch-utils'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup"
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import AnalyteCard from "@/components/lab/analyte/AnalyteCard"
import AnalyteRangeForm from '@/components/lab/analyte/AnalyteRangeForm'

export default {
  name: "AnalyteRange",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    AnalyteCard,
    AnalyteRangeForm
  },
  data () {
    return {
      loading: true,
      analyte_id: this.$route.params.analyte_id || null,
      analyte: null,
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/analytes",
            title: "Analyte list",
          },
          {
            icon: "fa-eye",
            linkto: `/analytes/${this.analyte_id}`,
            title: "View analyte",
            variant: "info",
          },
        ]
      }
    },
    sample_type() {
      return this.analyte.sample_type ? this.analyte.getSampleType() : null;
    },
    header() {
      return `${
        this.sample_type ? this.sample_type.name : "Sample Type not specified"
      }: ${this.analyte.name}`;
    },
  },
  async created () {
    this.loading = true

    this.analyte = await getModel({
      model_type: "analyte",
      id: this.analyte_id,
      message: this.$bvToast,
    });

    this.analyte ? (this.loading = false) : this.$router.back()
  }
}
</script>
